import {
  ColumnDef,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table"
import { AdminClub } from "@/types/shared"
import BasicTable from "@/shared/tables/BasicTable"

export const clubsColumns: ColumnDef<AdminClub>[] = [
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    accessorKey: "event_count",
    header: "Events",
    cell: (info) => {
      const value = info.getValue()
      return value === 0 ? "—" : value
    },
  },
]

interface ClubsTableProps {
  clubs: AdminClub[]
  onRowClick: (club: AdminClub) => void
}

export default function ClubsTable({ clubs, onRowClick }: ClubsTableProps) {
  const table = useReactTable({
    data: clubs,
    columns: clubsColumns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  return <BasicTable table={table} handleRowOnClick={(row) => onRowClick(row.original)} />
}
